import React from "react"
import styled from "styled-components"

import Step from "./step"
import Grid from "components/grid"

const GridWrapper = styled(Grid)`
  border-top: 1px solid ${props => props.theme.colors.paleGrey};
`

export type StepProps = {
  label: string
  paths: string[]
  labelMobile?: string
}

type StepNavProps = {
  steps: StepProps[]
}

function StepNav({ steps }: StepNavProps) {
  return (
    <GridWrapper rowProps={{ justifyContent: "space-around" }}>
      {steps.map(step => (
        <Step labelMobile={step.labelMobile} key={step.label} {...step} />
      ))}
    </GridWrapper>
  )
}

export default StepNav
